import {
  Checkbox,
  MenuItem,
  Select,
  Stack,
  TextField,
  FormControlLabel,
  Autocomplete,
  Grid,
} from "@mui/material"
import { useState, useContext } from "react"
import Modal from "../ui/Modal"
import FormItem from "../ui/FormItem"
import { DatePicker } from "../ui/DateTimePickers"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import {
  createExpense,
  createIncome,
  searchDepositor,
  uploadExpenseInvoice,
  searchAccountDepositor,
  searchExpenseHeads,
  searchExpenseSubHeads,
  searchIncomeHeads,
} from "../../api"
import UserContext from "../../contexts/user"
import { useSnackbar } from "notistack"
import { DropzoneArea } from "mui-file-dropzone"
import { v4 as uuid } from "uuid"
import { uploadInvoiceFile } from "../../utilities"

const entryType = [
  {
    label: "Income",
    value: "FEES",
  },
  {
    label: "Expense",
    value: "EXPENSE",
  },
]

const AddPayment = ({ isExpense, add, ...props }) => {
  const { user } = useContext(UserContext)
  const { enqueueSnackbar } = useSnackbar()

  const [feeDetails, setFeeDetails] = useState({
    entryType: isExpense ? "EXPENSE" : "",
    amount: "",
    currency: "INR",
    invoiceNumber: uuid(),
    purchaseOrder: "",
    generateInvoice: false,
    beneficiary: {
      id: user?.sub,
      label: user?.name,
    },
  })
  const [loading, setLoading] = useState(false)
  const [invoiceFile, setInvoiceFile] = useState(null)
  const [expenseHeads, setExpenseHeads] = useState([])
  const [expenseSubHeads, setExpenseSubHeads] = useState([])
  const [incomeHeads, setIncomeHeads] = useState([])
  const [inputValue, setInputValue] = useState("")
  const [inputAccountValue, setInputAccountValue] = useState("")
  const [inputExpenseHeadValue, setInputExpenseHeadValue] = useState("")
  const [inputExpenseSubHeadValue, setInputExpenseSubHeadValue] = useState("")
  const [inputIncomeHeadValue, setInputIncomeHeadValue] = useState("")
  const [students, setStudents] = useState([])
  const [studentsAcc, setStudentsAcc] = useState([])

  const handleChange = (event) => {
    const { name, value } = event.target
    setFeeDetails({
      ...feeDetails,
      [name]: value,
    })
  }

  const handleSubmit = async () => {
    setLoading(true)
    const externals = {}
    if (feeDetails.entryType === "EXPENSE") {
      if (!feeDetails?.expenseHeadId)
        externals["expenseHead"] = inputExpenseHeadValue
      if (!feeDetails?.expenseSubHeadId)
        externals["expenseSubHead"] = inputExpenseSubHeadValue
      if (feeDetails.beneficiary.label !== inputValue) {
        externals["externalBeneficiaryName"] = inputValue
      } else {
        externals["beneficiaryId"] = feeDetails.beneficiary.id
      }

      const reqBody = {
        ...feeDetails,
        ...externals,
      }

      if (invoiceFile !== null && invoiceFile.length > 0) {
        var formdata = new FormData()
        formdata.append("file", invoiceFile[0])
        uploadExpenseInvoice(formdata)
          .then((res) => {
            enqueueSnackbar("Invoices uploaded", { variant: "success" })
            createExpense({
              ...reqBody,
              billUrl: res.data.billUrl,
            })
              .then(() => {
                if (add) add(feeDetails)
                enqueueSnackbar("Expense added.", { variant: "success" })
                props.refresh()
                props.close()
              })
              .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
              .finally(() => setLoading(false))
          })
          .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
          .finally(() => {
            setLoading(false)
          })
      } else {
        createExpense(reqBody)
          .then(() => {
            if (add) add(feeDetails)
            enqueueSnackbar("Expense added.", { variant: "success" })
            props.refresh()
            props.close()
          })
          .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
          .finally(() => setLoading(false))
      }
    } else if (feeDetails.entryType === "FEES") {
      if (!feeDetails?.incomeHeadId)
        externals["incomeHead"] = inputIncomeHeadValue
      if (feeDetails?.depositor?.label !== inputValue) {
        externals["externalDepositorName"] = inputValue
      } else {
        externals["depositorId"] = feeDetails.depositor.id
      }

      const reqBody = {
        ...feeDetails,
        ...externals,
      }
      if (invoiceFile !== null && invoiceFile.length > 0) {
        uploadInvoiceFile(invoiceFile[0])
          .then((res) =>
            createIncome({ ...reqBody, proof: res?.data?.billUrl })
          )
          .then(() => {
            enqueueSnackbar("Income added.", { variant: "success" })
            props.refresh()
            props.close()
          })
          .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
          .finally(() => setLoading(false))
      } else {
        createIncome(reqBody)
          .then(() => {
            enqueueSnackbar("Income added.", { variant: "success" })
            props.refresh()
            props.close()
          })
          .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
          .finally(() => setLoading(false))
      }
    }
  }

  const [searching, setSearching] = useState(false)

  const fetchExpenseHeads = (value) => {
    searchExpenseHeads(value)
      .then((res) =>
        setExpenseHeads(res.data.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setSearching(false))
  }

  const [searching2, setSearching2] = useState(false)

  const fetchExpenseSubHeads = (value) => {
    searchExpenseSubHeads(value)
      .then((res) =>
        setExpenseSubHeads(res.data.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setSearching2(false))
  }

  const [searching3, setSearching3] = useState(false)

  const fetchIncomeHeads = (value) => {
    searchIncomeHeads(value)
      .then((res) =>
        setIncomeHeads(res.data.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setSearching3(false))
  }
  const [searching4, setSearching4] = useState(false)
  const searchStudents = (value) => {
    searchDepositor(value)
      .then((res) =>
        setStudents(res.data.rows.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setSearching4(false))
  }

  const [searching5, setSearching5] = useState(false)

  const searchStudentsAccounts = (value) => {
    searchAccountDepositor({
      keyword: value,
    })
      .then((res) =>
        setStudentsAcc(res.data.rows.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setSearching5(false))
  }

  const uploadInvoice = (event) => setInvoiceFile(event)

  return (
    <Modal
      {...props}
      title={isExpense ? "Add Expense" : "Add Entry"}
      actionText={"Add"}
      action={handleSubmit}
      loading={loading}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack>
          <Stack direction={"row"} spacing={2} alignItems="center">
            {!isExpense && (
              <FormItem label="Entry type">
                <Select
                  name="entryType"
                  value={feeDetails.entryType}
                  onChange={handleChange}
                >
                  {entryType.map((type) => (
                    <MenuItem value={type.value}>{type.label}</MenuItem>
                  ))}
                </Select>
              </FormItem>
            )}
          </Stack>

          {feeDetails.entryType === "EXPENSE" && (
            <Stack direction={"row"} spacing={2} alignItems="center">
              <FormItem label="Expense Head">
                <Autocomplete
                  loading={searching}
                  freeSolo
                  value={feeDetails.expenseHeadId}
                  onChange={(_, newValue) => {
                    setFeeDetails({
                      ...feeDetails,
                      expenseHeadId: newValue?.id,
                    })
                  }}
                  inputValue={inputExpenseHeadValue}
                  onInputChange={(_, newInputValue) => {
                    setInputExpenseHeadValue(newInputValue)
                    fetchExpenseHeads(newInputValue)
                  }}
                  getOptionLabel={(option) => option.label}
                  options={expenseHeads}
                  renderInput={(params) => <TextField {...params} />}
                />
              </FormItem>
              <FormItem label="Expense Sub Head">
                <Autocomplete
                  loading={searching2}
                  freeSolo
                  value={feeDetails.expenseSubHeadId}
                  onChange={(_, newValue) => {
                    setFeeDetails({
                      ...feeDetails,
                      expenseSubHeadId: newValue?.id,
                    })
                  }}
                  inputValue={inputExpenseSubHeadValue}
                  onInputChange={(_, newInputValue) => {
                    setInputExpenseSubHeadValue(newInputValue)
                    fetchExpenseSubHeads(newInputValue)
                  }}
                  getOptionLabel={(option) => option.label}
                  options={expenseSubHeads}
                  renderInput={(params) => <TextField {...params} />}
                />
              </FormItem>
            </Stack>
          )}
          {feeDetails.entryType === "FEES" && (
            <Stack direction={"row"} spacing={2} alignItems="center">
              <FormItem label="Income Head">
                <Autocomplete
                  loading={searching3}
                  freeSolo
                  value={feeDetails.incomeHeadId}
                  onChange={(_, newValue) => {
                    setFeeDetails({
                      ...feeDetails,
                      incomeHeadId: newValue?.id,
                    })
                  }}
                  inputValue={inputIncomeHeadValue}
                  onInputChange={(_, newInputValue) => {
                    setInputIncomeHeadValue(newInputValue)
                    fetchIncomeHeads(newInputValue)
                  }}
                  getOptionLabel={(option) => option.label}
                  options={incomeHeads}
                  renderInput={(params) => <TextField {...params} />}
                />
              </FormItem>
              <FormItem label="Particulars">
                <TextField
                  name="particulars"
                  value={feeDetails.particulars}
                  onChange={handleChange}
                />
              </FormItem>
            </Stack>
          )}
          <Stack direction={"row"} spacing={2} alignItems="center">
            <FormItem label="Amount">
              <Grid container spacing={1} width={"100% "}>
                <Grid item xs={3}>
                  <Select
                    disabled
                    name="currency"
                    value={feeDetails.currency}
                    onChange={handleChange}
                    fullWidth
                  >
                    <MenuItem value="INR">₹</MenuItem>
                    <MenuItem value="USD">$</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    name="amount"
                    value={feeDetails.amount}
                    onChange={handleChange}
                    fullWidth
                    type={"number"}
                  />
                </Grid>
              </Grid>
            </FormItem>
            <FormItem label="Payment Date">
              <DatePicker
                name="creationTimestamp"
                value={feeDetails.creationTimestamp}
                onChange={(date) =>
                  setFeeDetails({
                    ...feeDetails,
                    creationTimestamp: date,
                  })
                }
              />
            </FormItem>
          </Stack>

          <Stack direction={"row"} spacing={2} alignItems="center">
            {feeDetails.entryType === "FEES" && (
              <FormItem label="Depositor Name">
                <Autocomplete
                  loading={searching4}
                  freeSolo
                  value={feeDetails.depositor}
                  onChange={(_, newValue) => {
                    setFeeDetails({
                      ...feeDetails,
                      depositor: newValue,
                    })
                  }}
                  inputValue={inputValue}
                  onInputChange={(_, newInputValue) => {
                    setInputValue(newInputValue)
                    searchStudents(newInputValue)
                  }}
                  getOptionLabel={(option) => option.label}
                  options={students}
                  renderInput={(params) => <TextField {...params} />}
                />
              </FormItem>
            )}{" "}
            {feeDetails.entryType === "EXPENSE" && (
              <FormItem label="Benficiary Name">
                <Autocomplete
                  loading={searching4}
                  freeSolo
                  value={feeDetails.beneficiary}
                  onChange={(_, newValue) => {
                    setFeeDetails({
                      ...feeDetails,
                      beneficiary: newValue,
                    })
                  }}
                  inputValue={inputValue}
                  onInputChange={(_, newInputValue) => {
                    setInputValue(newInputValue)
                    searchStudents(newInputValue)
                  }}
                  getOptionLabel={(option) => option.label}
                  options={students}
                  renderInput={(params) => <TextField {...params} />}
                  disabled={isExpense}
                />
              </FormItem>
            )}
            <FormItem label="Account Name">
              <Autocomplete
                loading={searching5}
                value={feeDetails.accountId}
                onChange={(_, newValue) => {
                  setFeeDetails({
                    ...feeDetails,
                    accountId: newValue?.id,
                  })
                }}
                inputValue={inputAccountValue}
                onInputChange={(_, newInputValue) => {
                  setInputAccountValue(newInputValue)
                  searchStudentsAccounts(newInputValue)
                }}
                getOptionLabel={(option) =>
                  option.accountName + " - " + option.type
                }
                options={studentsAcc}
                renderInput={(params) => <TextField {...params} />}
              />
            </FormItem>
          </Stack>
          {feeDetails.entryType === "EXPENSE" && (
            <>
              <Stack direction={"row"} spacing={2} alignItems="center">
                <FormItem label="Voucher Number">
                  <TextField
                    disabled
                    name="invoiceNumber"
                    value={feeDetails.invoiceNumber}
                    onChange={handleChange}
                  />
                </FormItem>
              </Stack>
              <FormItem label="Upload Invoice">
                <DropzoneArea
                  filesLimit={1}
                  onChange={uploadInvoice}
                  acceptedFiles={["application/pdf"]}
                  useChipsForPreview
                />
              </FormItem>
            </>
          )}
          {feeDetails.entryType === "FEES" && (
            <>
              <FormItem label="Attach proof">
                <DropzoneArea
                  filesLimit={1}
                  onChange={uploadInvoice}
                  acceptedFiles={["application/pdf"]}
                  useChipsForPreview
                />
              </FormItem>{" "}
              <Stack direction={"row"} alignItems="center">
                <FormControlLabel
                  onChange={() =>
                    setFeeDetails({
                      ...feeDetails,
                      generateInvoice: !feeDetails.generateInvoice,
                    })
                  }
                  sx={{ ml: 0 }}
                  name="generateInvoice"
                  control={<Checkbox checked={feeDetails.generateInvoice} />}
                  label="Generate Invoice"
                  labelPlacement="start"
                />
              </Stack>
            </>
          )}
        </Stack>
      </LocalizationProvider>
    </Modal>
  )
}

export default AddPayment
